// Document ready
$(() => {
  window.utils.enableDisclosure();
  const oldFlickityCreate = window.Flickity.prototype._create;

  window.Flickity.prototype._create = function () {
    const that = this;
    if (this.element.addEventListener) {
      this.element.addEventListener('load', () => {
        that.onresize();
      }, true);
    }
    this._create = oldFlickityCreate;
    return oldFlickityCreate.apply(this, arguments);
  };

  // Support for background images with new Lazysizes library
  document.addEventListener('lazyloaded', e => {
    let bg = e.target.getAttribute('data-bg');
    const mobileBg = e.target.getAttribute('data-mobile-bg');
    if (bg) {
      if (window.Shopify.media_queries.medium.matches && mobileBg) {
        bg = mobileBg;
      }
      e.target.style.backgroundImage = `url(${bg})`;
    }
  });

  // Call to flickity fix for sliders on IOS
  window.imageFunctions.flickityIosFix();

  window.objectFitImages();
  window.header.loadMegaMenu();
  window.header.init();
  if (window.Shopify.theme_settings.enable_autocomplete) {
    window.searchAutocomplete.init();
  }
  window.utils.pageBannerCheck();
  window.slideshow.init();
  window.testimonials.init();
  window.video.init();
  window.gallery.init();
  window.videoFeature.setupVideoPlayer();
  window.featuredPromotions.init();
  window.featuredCollection.init();
  window.collectionSidebarFilter.init();
  window.cart.init();
  window.map.init();
  window.productPage.init();
  window.productPage.runOptionSelector();
  window.productPage.initializeQuantityBox();
  window.recentlyViewed.init();
  window.sidebarAccordions.init();

  if (window.Currency.show_multiple_currencies || window.Currency.native_multi_currency) {
    window.currencyConverter.init();
  }

  // Challenge page scroll

  // Return the pathname of the current URL
  const { pathname } = location;

  // If the pathname starts with '/challenge', animate scroll
  if (pathname.startsWith('/challenge')) {
    $('html, body').animate({
      scrollTop: 0,
    }, 'slow');
  }

  // Product review scroll
  window.utils.productReviewScroll();

  // Setup a timer
  let resizeTimeout;
  // Grab screen width before screen is resized
  const beforeResizeWidth = $(window).width();

  // Listen for resize events
  window.addEventListener('resize', () => {
    // If timer is null, reset it to 66ms and run your functions.
    // Otherwise, wait until timer is cleared
    if (!resizeTimeout) {
      resizeTimeout = setTimeout(() => {
        // Reset timeout
        resizeTimeout = null;
        // Grab screen width after screen is resized
        const currentScreenWidth = $(window).width();
        // Run our resize functions
        if (window.Shopify.media_queries.medium.matches && currentScreenWidth !== beforeResizeWidth) {
          window.cart.init();
          if (!window.is_touch_device()) {
            window.header.unload();
            window.header.init();
          }
        }

        // swap lazysizes background mobile images when browser is resized
        const lazysizesBackgroundImages = document.querySelectorAll('[data-bg]');
        lazysizesBackgroundImages.forEach(image => {
          let bg = image.getAttribute('data-bg');
          const mobileBg = image.getAttribute('data-mobile-bg');

          if (bg) {
            if (window.Shopify.media_queries.medium.matches && mobileBg) {
              bg = mobileBg;
            }

            image.style.backgroundImage = `url(${bg})`;
          }
        });
      }, 66);
    }
  }, false);

  // Lightbox default options
  // https://fancyapps.com/fancybox/3/docs/#options
  $.fancybox.defaults.animationEffect = 'fade';
  $.fancybox.defaults.transitionEffect = 'fade';
  $.fancybox.defaults.hash = false;
  $.fancybox.defaults.infobar = false;
  $.fancybox.defaults.toolbar = false;
  $.fancybox.defaults.arrows = false;
  $.fancybox.defaults.loop = true;
  $.fancybox.defaults.smallBtn = true;
  $.fancybox.defaults.live = false;
  $.fancybox.defaults.zoom = false;
  $.fancybox.defaults.mobile.preventCaptionOverlap = false;
  $.fancybox.defaults.mobile.toolbar = true;
  $.fancybox.defaults.mobile.buttons = ['close'];
  $.fancybox.defaults.mobile.clickSlide = 'close';
  $.fancybox.defaults.mobile.clickContent = 'zoom';
  $.fancybox.defaults.afterLoad = function (instance, slide) {
    if (instance.current.type === 'image') {
      slide.$content.wrapInner("<div class='fancybox-image-wrap'></div>");
    }
    if (instance.group.length > 1) {
      slide.$content.find('.fancybox-image-wrap').append(`<a title="Previous" class="fancybox-item fancybox-nav fancybox-prev" href="javascript:;" data-fancybox-prev><span>${window.svgArrowSizeLeft}</span></a><a title="Next" class="fancybox-item fancybox-nav fancybox-next" href="javascript:;" data-fancybox-next><span>${svgArrowSizeRight}</span></a>`);
    }
  };

  // backwards compatibility with custom lightboxes
  $('.lightbox[rel="gallery"]').fancybox();

  // Find youtube and vimeo iframes
  const $videoIframes = $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"], iframe[src*="facebook.com/plugins/video"]');

  // For each iframe, if parent is a responsive video wrapper do nothing
  // If no parent responsive video wrapper, then wrap iframe in responsive video wrapper

  function getAspectRatio(width, height) {
    const ratio = width / height;

    // Determine ratio to be used
    if (Math.abs(ratio - 1 / 1) === 0) {
      return '1:1';
    }
    return (Math.abs(ratio - 4 / 3) < Math.abs(ratio - 16 / 9)) ? '4:3' : '16:9';
  }

  $videoIframes.each((_index, iframe) => {
    // Update selector
    const $iframe = $(iframe);

    // Grab src
    const source = $iframe.attr('src');

    if (!$iframe.parents('.plyr__video-wrapper').length && !$iframe.parents('.lazyframe').length) {
      $iframe.wrap(`<div class="lazyframe" data-ratio="${getAspectRatio($iframe.attr('width'), $iframe.attr('height'))}" data-src="${source}"></div>`);
    }
  });

  // Initiate lazyframe
  window.lazyframe('.lazyframe');

  // Wrap shopify policy in grid layout classes
  $('.shopify-policy__container').wrap('<section class="section shopify-policy-template"><div class="container content"></div>');

  // Prevent header overlap on dynamically generated policy pages. Add pagecontent tag to match current page structure.
  $('.shopify-policy__container').closest('.section').prepend('<a name="pagecontent" id="pagecontent"></a>');

  // Add classes to determine column size
  $('.shopify-policy__container').addClass('five-eighths offset-by-three columns is-hidden-offset-mobile-only medium-down--one-whole');

  // Add featured divider beneath page title
  $('.shopify-policy__title').append('<div class="feature_divider"></div>');

  // Search input hiding
  // get current input
  const currentValue = $(".search__form input[name='q']").val();
  // return amount without *
  if ($(".search__form input[name='q']").length > 0) {
    $(".search__form input[name='q']").val(currentValue.replace('*', ''));
  }

  $('#sort-by').val($('#sort-by').data('default-sort'));

  $('body')
    .on('change', '#sort-by', () => {
      window.quickFilter.init();
    });

  $('body')
    .on('change', '#tag_filter', () => {
      $('[data-option-filter] input').prop('checked', false);
      window.quickFilter.init();
    });

  $('body')
    .on('change', '#blog_filter', function () {
      const url = $(this).val();
      window.location = url;
    });

  $('input, select, textarea').on('focus blur', event => {
    $('meta[name=viewport]').attr('content', `width=device-width,initial-scale=1,maximum-scale=${event.type === 'blur' ? 10 : 1}`);
  });

  // Collection sidebar filter
  // Check the checkbox values
  $('body').on('change', '[data-option-filter] input', () => {
    window.quickFilter.init();
    $('html, body').animate({
      scrollTop: ($('#pagecontent').offset().top),
    }, 500);
  });

  $('body').on('click', '[data-reset-filters]', () => {
    window.collectionSidebarFilter.clearAllFilters();
  });

  $('body').on('click', '[data-clear-filter]', e => {
    const $this = $(e.currentTarget);
    const selectedOption = $this.parents('.filter-active-tag');
    window.collectionSidebarFilter.clearSelectedFilter(selectedOption);
  });

  $('body').on('change', '.currencies', () => {
    $('[data-initial-modal-price]').attr('data-initial-modal-price', '');
  });

  $("body").on(
    "change",
    ".js-quick-shop select, .js-quick-shop-sheet-content select",
    () => {
      const currentVariant = $(
        '.js-quick-shop select[name="id"], .js-quick-shop-sheet-content select[name="id"]'
      )
        .first()
        .val();
      if (currentVariant && window.globalQuickShopProduct) {
        window.quickShop.updateVariant(currentVariant);
      }
    }
  );

  if (window.Shopify.theme_settings.quick_shop_enabled) {
    window.quickShop.init();
  }

  let touchStartPos = 0;

  // Detecting swipe vs tap
  $(document).bind('touchstart', () => {
    touchStartPos = $(window).scrollTop();
  }).bind('touchend', e => {
    const distance = touchStartPos - $(window).scrollTop();
    if (distance > 20 || distance < -20) {
      e.preventDefault;
    }
  });

  $('body').on('click', '.sidebar .parent-link--false', function (e) {
    e.preventDefault();
    const $menu = $(this).parent('li');
    $menu.find('.menu-toggle').toggleClass('active');
    $menu.find('ul').slideToggle();
  });

  if (window.Shopify.theme_settings.newsletter_popup) {
    window.newsletter_popup.init();
  }

  if (window.location.pathname.indexOf('/comments') !== -1) {
    $('html,body').animate({ scrollTop: $('#new-comment').offset().top - 140 }, 'slow');
  }

  $('body').on('mouseenter', '.icon-search', () => {
    $('.search-terms').focus();
  });

  $('body').on('click', '.icon-search', () => {
    $('input.search-terms').focus();
  });

  $('body').on('click', '.search-submit', e => {
    const $this = $(e.currentTarget);
    $this.parent().submit();
  });

  if (window.Shopify.media_queries.large.matches) {
    $('.animate_right').waypoint(function () {
      $(this.element).addClass('animated fadeInRight');
    }, { offset: '70%' });
    $('.animate_left').waypoint(function () {
      $(this.element).addClass('animated fadeInLeft');
    }, { offset: '70%' });
    $('.animate_up').waypoint(function () {
      $(this.element).addClass('animated fadeInUp');
    }, { offset: '70%' });
    $('.animate_down').waypoint(function () {
      $(this.element).addClass('animated fadeInDown');
    }, { offset: '70%' });
  }

  // backwards compatibility with flexslider
  $('.slider, .flexslider').find('li').unwrap();
  $('.slider, .flexslider').flickity({
    pageDots: window.usePageDots,
    imagesLoaded: true,
    arrowShape: window.arrowSize,
    lazyLoad: 2,
  });

  window.utils.createAccordion('.footer_menu', 'h6', 'ul');
  window.utils.createAccordion('.footer_content', 'h6', 'div.toggle_content');
  window.utils.createAccordion('.product_section .accordion-tabs', '.tabs li > a', '.tabs-content li');
  window.utils.mobileParentActiveAccordion('#mobile_menu', 'li.sublink > a.parent-link--true span', 'li.sublink ul');
  window.utils.mobileAccordion('#mobile_menu', 'li.sublink > a.parent-link--false', 'li.sublink ul');

  window.utils.initializeTabs();
  window.accordion.init();

  $('body').on('click', '.menu-toggle', function () {
    const $content = $(this).next('ul');
    $content.slideToggle();
    $(this).toggleClass('active');
    $(this).attr('aria-expanded', $(this).attr('aria-expanded') === 'true' ? 'false' : 'true');
  });

  if (window.Shopify.theme_settings.collection_swatches) {
    if (window.Shopify.media_queries.large.matches) {
      $('body').on('mouseenter', '.collection_swatches', function () {
        $('.swatch span', $(this)).each(function () {
          if ($(this).data('image').indexOf('no-image') === -1) {
            $('<img/>')[0].src = $(this).data('image');
          }
        });
      });
      $('body').on('mouseenter', '.swatch span', function () {
        if ($(this).data('image').indexOf('no-image') === -1) {
          $(this).parents('.thumbnail').find('.image__container img:not(.secondary)').attr('src', $(this).data('image'));
          $(this).parents('.thumbnail').find('.image__container img:not(.secondary)').attr('srcset', $(this).data('image'));
        }
      });
    }
  }

  // Terms of service settings for minicart
  if (window.Shopify.theme_settings.display_tos_checkbox) {
    $('body').on('click touchstart', '.cart_content .tos_label', function () {
      $(this).prev('input').prop('checked', true);
    });
  }

  if (window.Shopify.theme_settings.display_tos_checkbox && window.Shopify.theme_settings.go_to_checkout) {
    // Terms of service on mini-cart && cart page
    $('body').on('click', '.tos_warning [data-cart-checkout-button]', function (e) {
      if ($(this).parents('form').find('.tos_agree').is(':checked')) {
        // Check if we are on the cart page or mini cart
        if (window.Shopify.theme_settings.go_to_checkout || $('body').hasClass('cart')) {
          $(this).submit();
        } else {
          // Redirect to cart page
          e.preventDefault();
          document.location.href = Shopify.routes.cart_url;
        }
      } else {
        const warning = `<p class="warning animated bounceIn">${Shopify.translation.agree_to_terms_warning }</p>`;
        if ($('p.warning').length === 0) {
          $(this).before(warning);
        }
        return false;
      }
    });
  } else if (!window.Shopify.theme_settings.go_to_checkout) {
    $('body').on('click', '.cart_content [data-minicart-checkout-button]', e => {
      // Redirect to cart page
      e.preventDefault();
      document.location.href = window.Shopify.routes.cart_url;
    });
  }

  if (window.Shopify.theme_settings.collection_secondary_image) {
    window.imageFunctions.showSecondaryImage();
  }

  // Contact form checkbox validation
  if ($('[data-is-required]').length) {
    const $checkboxGroup = $('.contact-block--checkbox input');
    $checkboxGroup.prop('required', true);

    $('.contact-block--checkbox [data-is-required] input').on('change', () => {
      $checkboxGroup.prop('required', true);
      if ($checkboxGroup.is(':checked')) {
        $checkboxGroup.prop('required', false);
      }
    });
  }

  $('.maps').click(() => {
    $('.maps iframe').css('pointer-events', 'auto');
  });

  if (window.Shopify.theme_settings.pagination_type === 'load_more_button') {
    window.enableLoadMoreButton('.collection-matrix');
  }

  if (window.Shopify.theme_settings.pagination_type === 'load_more') {
    window.enableLoadMoreProducts();
  }

  if (window.Shopify.theme_settings.pagination_type === 'infinite_scroll') {
    window.enableInfiniteScroll();
  }

  if (window.Shopify.theme_settings.search_pagination_type === 'load_more_button') {
    window.enableLoadMoreButton('.search-matrix');
  }

  if (window.Shopify.theme_settings.search_pagination_type === 'load_more') {
    window.enableLoadMoreSearch();
  }

  if (window.Shopify.theme_settings.search_pagination_type === 'infinite_scroll') {
    window.enableInfiniteSearchScroll();
  }

  /*= ===========================================================================
    Start of cart-related functionality
  ============================================================================== */

  function ajaxSubmitCart(cart) {
    const $cart = cart;
    $.ajax({
      url: '/cart/update.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: $cart.serialize(),
      success(data) {
        refreshCart(data);
      },
    });
  }

  function updateCartItemQuantity(cartItem) {
    $.ajax({
      url: '/cart/change.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: {
        quantity: cartItem.quantity,
        line: cartItem.lineID,
      },
      success(data) {
        const cartItemsArray = data.items;
        const lineIDIndex = cartItem.lineID - 1;
        const totalCartItems = cartItem.parentCartForm.find('[data-variant-id]').length;
        const $quantityInputs = cartItem.parentCartForm.find(`[data-variant-id="${cartItem.variantID}"] input`);
        let initialQuantityTotal = 0;
        let apiQuantityTotal = 0;
        const apiLineItemQuantity = typeof data.items[lineIDIndex] !== 'undefined' ? data.items[lineIDIndex].quantity : 0;

        // Check if item has a "Buy X get Y" deal
        if ($quantityInputs.length > 1) {
          // Multiple inputs

          // Get all the quantities of same variants in the cart (including BOGO) in HTML
          $.each($quantityInputs, (_i, input) => {
            initialQuantityTotal += parseInt($(input).val());
          });

          // Get quantities from cart object returned from API
          cartItemsArray.forEach(item => {
            if (item.variant_id === cartItem.variantID) {
              apiQuantityTotal += item.quantity;
            }
          });
        } else {
          // Single input
          initialQuantityTotal = parseInt($quantityInputs.val());
          apiQuantityTotal = typeof data.items[lineIDIndex] !== 'undefined' ? data.items[lineIDIndex].quantity : 0;
        }

        // Checks to see if there is enough inventory to update to an increased amount
        if (initialQuantityTotal > 0 && initialQuantityTotal > apiQuantityTotal) {
          if (apiQuantityTotal === 1) {
            itemsLeftText = window.Shopify.translation.one_item_left;
          } else {
            itemsLeftText = window.Shopify.translation.items_left_text;
          }

          $('.warning--quantity').remove();

          // Check if Buy one get one product
          if (totalCartItems < cartItemsArray.length) {
            if (cartItem.parentCartForm.data('cart-form') === 'cart-template') {
              // Refreshes cart if inventory is available
              cartItem.parentCartForm.submit();
            } else {
              refreshCart(data);
            }
          } else {
            const warning = `<p class="warning warning--quantity animated bounceIn">${apiQuantityTotal} ${itemsLeftText}</p>`;
            cartItem.parentCartForm.find(`[data-line-id='${cartItem.lineID}'] input`).parent().after(warning);
            cartItem.parentCartForm.find(`[data-line-id='${cartItem.lineID}'] input`).val(apiLineItemQuantity);
          }
        } else if (cartItem.parentCartForm.data('cart-form') === 'cart-template') {
          // Refreshes cart if inventory is available
          cartItem.parentCartForm.submit();
        } else {
          refreshCart(data);
        }
      },
    });
  }

  function refreshCartID () {
    const cartItem = document.querySelectorAll('.cart__item');

    for (let i = 0; i < cartItem.length; i++) {
      const lineIndex = i + 1;
      const dataLineId = cartItem[i].querySelectorAll('[data-line-id]');

      for (let c = 0; c < dataLineId.length; c++) {
        dataLineId[c].dataset.lineId = lineIndex;
      }
    }
  }
  
  let freeEbook = 47406069154128;
  let paidEbook = 40558528757821;

  function addEbook(fid) {
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: fid // ebook id
      },
        dataType: 'json', 
       success: function (data) {
        $.ajax({
          url: '/cart.js',
          dataType: 'json',
          cache: false,
          success(cart) {
            setTimeout(function () {
              
              if(window.location.href.includes('cart')){

              } else {
                refreshCart(cart);
              }
            }, 500);
          }
        });

       
      },
       error(XMLHttpRequest) {

        console.log(XMLHttpRequest);

      },
    });
  }

  function removeEbook(fid) {
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: {
        id: fid,
        quantity: 0
      },
      dataType: 'json', 
      success: function (data) {
        $.ajax({
          url: '/cart.js',
          dataType: 'json',
          cache: false,
          success(cart) {
            setTimeout(function () {
              
              if(window.location.href.includes('cart')){

              } else {
                refreshCart(cart);
              }
            }, 500);
          }
        });
      },
      error(XMLHttpRequest) {

       console.log(XMLHttpRequest);

     }
    })
  }

  function refreshCart(cart) {
    $('.cart_count').empty();
    const $cartBtn = $('.cart_count');
    const value = $cartBtn.text() || '0';
    let cartItemsHTML = "";
    let cartDiscountsHTML = "";
    let cartActionHTML = "";
    let cartSavingsHTML = "";
    let cartEbook = "";
    const $cartForm = $('[data-cart-form]');
    let productHasSale = false;
    let productCompareAtPrice = 0;
    let productFinalPrice = 0;

    $cartForm.data('total-discount', cart.total_discount);

    $cartBtn.text(value.replace(/[0-9]+/, cart.item_count));

    if (cart.item_count === 0) {
      $('.js-empty-cart__message').removeClass('hidden');
      $cartForm.addClass('hidden');
    } else {
      $('.js-empty-cart__message').addClass('hidden');
      $cartForm.removeClass('hidden');

      let totalSaving = 0; // adding counter variables for total cart savings
      let saving = 0;

      $.each(cart.items, (index, item) => {
        const itemDiscounts = item.discounts;
        let discountMessage = '';

        for (let i = 0; i < itemDiscounts.length; i++) {
          const { title } = itemDiscounts[i];
          discountMessage = `<p class="notification-discount meta">${title}</p>`;
        }
        const lineID = index + 1;

        cartItemsHTML += `<li class="mini-cart__item" data-cart-item data-line-id="${lineID}" data-variant-id="${item.id}">`
          + `<a href="${item.url}">`;
        if (item.image) {
          cartItemsHTML += `${'<div class="cart_image">'
              + '<img src="'}${item.image.replace(/(\.[^.]*)$/, '_compact$1').replace('http:', '')}" alt="${htmlEncode(item.title)}" />`
            + '</div></a>';
        }

        cartItemsHTML += `<div class="mini-cart__item-content"><div class="mini-cart__item-title"><a href="${item.url}">${item.title}</a>`;

        if (item.selling_plan_allocation) {
          cartItemsHTML += `<div class="meta">${item.selling_plan_allocation.selling_plan.name}</div>`;
        }

        if (item.properties) {
          $.each(item.properties, (title, value) => {
            if (value) {
              if (title.includes("_essential_preorder")) {
              } else {
                cartItemsHTML += `<div class="line-item">${title}: ${value} </div>`;
              }
            }
          });
        }

        cartItemsHTML += '</div><div class="mini-cart__item-price">';

        $.ajax({
          dataType: 'json',
          async: false,
          cache: false,
          url: `/products/${item.handle}.js`,
          success(data) {
            let productData = data;
            // If item has more than one variant, need to make sure we are pulling data from the correct variant
            if (productData.variants) {
              const itemVariants = productData.variants;
              if (itemVariants.length > 1) {
                for (let v = 0; v < itemVariants.length; v++) {
                  if (itemVariants[v].id === item.id) {
                    productData = itemVariants[v];
                  }
                }
              }
            }

            // If compare at price exists then item is on sale
            if (productData.compare_at_price) {
              if (productData.compare_at_price > productData.price) {
                productHasSale = true;
                productCompareAtPrice = productData.compare_at_price;
                productFinalPrice = productData.price;
              }
            } else {
              // Check required for non-sale items
              productHasSale = false;
            }
          },
        });

        if (productHasSale === true) {
          // puts the slash through the old item price
          const itemPrice = `${window.Shopify.formatMoney(productFinalPrice, $('body').data('money-format'))} </span><span class="money was_price">${window.Shopify.formatMoney(productCompareAtPrice, $('body').data('money-format'))}</span>`;
          cartItemsHTML += `<span class="money sale">${itemPrice}</strong>`;

          // Total savings
          saving = (productCompareAtPrice - productFinalPrice) * item.quantity;
          totalSaving = saving + totalSaving;
        } else if (item.price > item.final_price) {
          // puts the slash through the old item price
          const itemPrice = `${window.Shopify.formatMoney(item.final_price, $('body').data('money-format'))} </span><span class="money was_price">${window.Shopify.formatMoney(item.price, $('body').data('money-format'))}</span>`;
          cartItemsHTML += `<span class="money sale">${itemPrice}</strong>`;
        } else {
          const itemPrice = window.Shopify.formatMoney(item.price, $('body').data('money-format'));
          if (item.price > 0) {
            cartItemsHTML += `<span class="money">${itemPrice}</span></strong>`;
          } else {
            cartItemsHTML += `<span>${window.Shopify.translation.cart_free_text}</span></strong>`;
          }
        }

        cartItemsHTML += '</div>';

        // Unit price

        if (item.unit_price_measurement && item.price > 0) {
          let unitPriceMeasurementReferenceValue = '';

          if (item.unit_price_measurement.reference_value !== 1) {
            unitPriceMeasurementReferenceValue = item.unit_price_measurement.reference_value;
          }

          cartItemsHTML += `<p class="mini-cart__unit-price">${item.unit_price_measurement.quantity_value}${item.unit_price_measurement.quantity_unit} | ${Shopify.formatMoney(item.unit_price, $('body').data('money-format'))} / ${unitPriceMeasurementReferenceValue}${item.unit_price_measurement.reference_unit}</p>`;
        }

        if (item.price > item.final_price) {
          cartItemsHTML += discountMessage;
        }

        cartItemsHTML += '<div class="product-quantity-box">';
        cartItemsHTML += '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"></span></span>';
        cartItemsHTML += `<input type="number" min="0" class="quantity" name="updates[]" id="updates_${item.id}" value="${item.quantity}" data-cart-quantity-input="mini-cart" />`;
        cartItemsHTML += '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>';
        cartItemsHTML += '</div></div></div>';
        cartItemsHTML += `<a href="/cart/change?line=${lineID}&amp;quantity=0" class="js-cart-remove-btn cart__remove-btn" data-line-id="${lineID}" data-remove-item="mini-cart"><span class="remove-icon"></span></a>`;
      });

      const cartDiscounts = cart.cart_level_discount_applications;

      for (let i = 0; i < cartDiscounts.length; i++) {
        const amount = window.Shopify.formatMoney(cartDiscounts[i].total_allocated_amount, $('body').data('money-format'));
        const { title } = cartDiscounts[i];

        cartDiscountsHTML += `<span class="cart_discounts--title">${title}</span>`;
        cartDiscountsHTML += '<span class="cart_discounts--price">';
        cartDiscountsHTML += `-<span class="money">${amount}</span></span>`;
      }

      cartActionHTML += `<span class="right"><span class="money">${window.Shopify.formatMoney(cart.total_price, $('body').data('money-format'))}</span></span> <span>${Shopify.translation.cart_subtotal_text}</span>`;
      totalSaving += cart.total_discount;
      if (window.Shopify.theme_settings.display_savings && totalSaving > 0) {
        cartSavingsHTML = `<span class="right"><span class="money">${window.Shopify.formatMoney(totalSaving, $('body').data('money-format'))}</span></span>`
            + `<span>${window.Shopify.translation.cart_savings_text}</span>`;
      } else {
        cartSavingsHTML = '';
      }
    }
  if ( window.Shopify.theme_settings.display_ebook == true) {

    var ebookInCart = 0;
    var ebookPaidInCart = 0;
    var ebookFreeInCart = 0;
    var cTotal = 0;
    console.log(cart);
    cart.items.forEach((item, index) => {
      if(item.id == paidEbook) {
        ebookInCart += 1;
        ebookPaidInCart += 1;
        
      } else if( item.id == freeEbook ) {
        ebookInCart += 1;
        ebookFreeInCart += 1;
      } else {
        cTotal += item.final_price * item.quantity;
      }
    });

    // Market-contextual threshold (in cents) resolved on page load via theme settings.
    var ebookMargin = window.Shopify.theme_settings.ebook_free_threshold || 5000;
    ebookMissing = (ebookMargin - cTotal) * 0.01;
    
    if ( ebookInCart == 0 && ebookMissing < 0 ) {
      cartEbook =`<div class="ebook-line-item ebook-line-item--eligible">
        <div class="ebook-line-item__image"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11.2266 21.7969H12.7734" stroke="#B82C33" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
          <mask id="mask0_1062_1225" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
          <path d="M0 1.90735e-06H24V24H0V1.90735e-06Z" fill="white"></path>
          </mask>
          <g mask="url(#mask0_1062_1225)">
          <path d="M7.93359 3.45728C7.93359 3.65143 7.77623 3.80884 7.58203 3.80884C7.38783 3.80884 7.23047 3.65143 7.23047 3.45728C7.23047 3.26312 7.38783 3.10571 7.58203 3.10571C7.77623 3.10571 7.93359 3.26312 7.93359 3.45728Z" fill="#B82C33"></path>
          <path d="M9.53906 3.45728C9.53906 3.65143 9.3817 3.80884 9.1875 3.80884C8.9933 3.80884 8.83594 3.65143 8.83594 3.45728C8.83594 3.26312 8.9933 3.10571 9.1875 3.10571C9.3817 3.10571 9.53906 3.26312 9.53906 3.45728Z" fill="#B82C33"></path>
          <path d="M11.1445 3.45728C11.1445 3.65143 10.9872 3.80884 10.793 3.80884C10.5988 3.80884 10.4414 3.65143 10.4414 3.45728C10.4414 3.26312 10.5988 3.10571 10.793 3.10571C10.9872 3.10571 11.1445 3.26312 11.1445 3.45728Z" fill="#B82C33"></path>
          <path d="M3.70801 6.17505V1.79819C3.70801 0.999252 4.35563 0.35158 5.15462 0.35158H18.8455C19.6445 0.35158 20.2921 0.999252 20.2921 1.79819V6.17505" stroke="#B82C33" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
          <path d="M20.2921 18.993V22.2018C20.2921 23.0008 19.6445 23.6484 18.8455 23.6484H5.15462C4.35563 23.6484 3.70801 23.0008 3.70801 22.2018V18.993" stroke="#B82C33" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
          <path d="M18.3698 18.5322V19.4625C18.3698 19.8337 18.0689 20.1345 17.6978 20.1345H6.30237C5.93126 20.1345 5.63037 19.8337 5.63037 19.4625V18.5257" stroke="#B82C33" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
          <path d="M5.63037 4.64062V2.94591C5.63037 2.57475 5.93126 2.27391 6.30237 2.27391H17.6978C18.0689 2.27391 18.3698 2.57475 18.3698 2.94591V4.64062" stroke="#B82C33" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
          <path d="M5.63037 4.64062H18.3698" stroke="#B82C33" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
          <path d="M12 6.17724V18.5322" stroke="#B82C33" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
          <path d="M20.2634 14.0554V5.43534C20.2634 5.14969 20.0629 4.90505 19.7839 4.84383C15.818 3.97444 11.9999 6.17723 11.9999 6.17723C11.9999 6.17723 8.18177 3.97444 4.21581 4.84383C3.93681 4.90505 3.73633 5.14969 3.73633 5.43534V7.7498" stroke="#B82C33" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
          <path d="M3.73633 9.39338V16.6356C3.73633 17.015 4.08175 17.2993 4.45459 17.2288C7.71109 16.6134 10.8176 18.0054 11.7309 18.468C11.9 18.5536 12.0998 18.5536 12.2688 18.468C13.1821 18.0054 16.2887 16.6134 19.5452 17.2288C19.918 17.2993 20.2634 17.015 20.2634 16.6356V15.699" stroke="#B82C33" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
          <path d="M3.73655 6.17498C3.58711 6.20972 3.43904 6.24745 3.29269 6.28893L2.88525 6.40439C2.51086 6.51042 2.25244 6.85223 2.25244 7.24139V18.1559C2.25244 18.7331 2.80421 19.1502 3.35954 18.9929L4.07232 18.7909C7.25836 17.8882 10.4048 19.3799 11.5485 20.0187C11.8289 20.1752 12.1705 20.1754 12.4511 20.0194C13.5973 19.382 16.7562 17.8923 19.9279 18.7909L20.6407 18.9929C21.196 19.1502 21.7478 18.7331 21.7478 18.1559V7.24139C21.7478 6.85223 21.4894 6.51042 21.1149 6.40439L20.7075 6.28893C20.5612 6.24745 20.4131 6.20972 20.2636 6.17498" stroke="#B82C33" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
          </g>
          </svg>
        </div>
        <div class="ebook-line-item__content">
          <p class="ebook-line-item__title">${window.Shopify.theme_settings.ebook_title}</p>
          <p class="ebook-line-item__meta">${window.Shopify.theme_settings.eligible_not_in_cart_js_html.replace('{{currency_symbol}}', window.Currency.symbol)}</p>
          <span class="ebook-line-item__price">${window.Shopify.translation.cart_free_text}</span>
          <div class="add_to_cart_ebook ebook-line-item__add"><a class="btn btn-alternate">${window.Shopify.translation.add_to_cart}</a></div>
        </div>
      </div>`;
    } else if (ebookInCart > 0 && ebookMissing < 0) {
      cartEbook =`<div class="ebook-line-item ebook-line-item--added">
        <div class="ebook-line-item__image"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11.2266 21.7969H12.7734" stroke="#B82C33" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
          <mask id="mask0_1062_1225" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
          <path d="M0 1.90735e-06H24V24H0V1.90735e-06Z" fill="white"></path>
          </mask>
          <g mask="url(#mask0_1062_1225)">
          <path d="M7.93359 3.45728C7.93359 3.65143 7.77623 3.80884 7.58203 3.80884C7.38783 3.80884 7.23047 3.65143 7.23047 3.45728C7.23047 3.26312 7.38783 3.10571 7.58203 3.10571C7.77623 3.10571 7.93359 3.26312 7.93359 3.45728Z" fill="#B82C33"></path>
          <path d="M9.53906 3.45728C9.53906 3.65143 9.3817 3.80884 9.1875 3.80884C8.9933 3.80884 8.83594 3.65143 8.83594 3.45728C8.83594 3.26312 8.9933 3.10571 9.1875 3.10571C9.3817 3.10571 9.53906 3.26312 9.53906 3.45728Z" fill="#B82C33"></path>
          <path d="M11.1445 3.45728C11.1445 3.65143 10.9872 3.80884 10.793 3.80884C10.5988 3.80884 10.4414 3.65143 10.4414 3.45728C10.4414 3.26312 10.5988 3.10571 10.793 3.10571C10.9872 3.10571 11.1445 3.26312 11.1445 3.45728Z" fill="#B82C33"></path>
          <path d="M3.70801 6.17505V1.79819C3.70801 0.999252 4.35563 0.35158 5.15462 0.35158H18.8455C19.6445 0.35158 20.2921 0.999252 20.2921 1.79819V6.17505" stroke="#B82C33" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
          <path d="M20.2921 18.993V22.2018C20.2921 23.0008 19.6445 23.6484 18.8455 23.6484H5.15462C4.35563 23.6484 3.70801 23.0008 3.70801 22.2018V18.993" stroke="#B82C33" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
          <path d="M18.3698 18.5322V19.4625C18.3698 19.8337 18.0689 20.1345 17.6978 20.1345H6.30237C5.93126 20.1345 5.63037 19.8337 5.63037 19.4625V18.5257" stroke="#B82C33" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
          <path d="M5.63037 4.64062V2.94591C5.63037 2.57475 5.93126 2.27391 6.30237 2.27391H17.6978C18.0689 2.27391 18.3698 2.57475 18.3698 2.94591V4.64062" stroke="#B82C33" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
          <path d="M5.63037 4.64062H18.3698" stroke="#B82C33" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
          <path d="M12 6.17724V18.5322" stroke="#B82C33" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
          <path d="M20.2634 14.0554V5.43534C20.2634 5.14969 20.0629 4.90505 19.7839 4.84383C15.818 3.97444 11.9999 6.17723 11.9999 6.17723C11.9999 6.17723 8.18177 3.97444 4.21581 4.84383C3.93681 4.90505 3.73633 5.14969 3.73633 5.43534V7.7498" stroke="#B82C33" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
          <path d="M3.73633 9.39338V16.6356C3.73633 17.015 4.08175 17.2993 4.45459 17.2288C7.71109 16.6134 10.8176 18.0054 11.7309 18.468C11.9 18.5536 12.0998 18.5536 12.2688 18.468C13.1821 18.0054 16.2887 16.6134 19.5452 17.2288C19.918 17.2993 20.2634 17.015 20.2634 16.6356V15.699" stroke="#B82C33" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
          <path d="M3.73655 6.17498C3.58711 6.20972 3.43904 6.24745 3.29269 6.28893L2.88525 6.40439C2.51086 6.51042 2.25244 6.85223 2.25244 7.24139V18.1559C2.25244 18.7331 2.80421 19.1502 3.35954 18.9929L4.07232 18.7909C7.25836 17.8882 10.4048 19.3799 11.5485 20.0187C11.8289 20.1752 12.1705 20.1754 12.4511 20.0194C13.5973 19.382 16.7562 17.8923 19.9279 18.7909L20.6407 18.9929C21.196 19.1502 21.7478 18.7331 21.7478 18.1559V7.24139C21.7478 6.85223 21.4894 6.51042 21.1149 6.40439L20.7075 6.28893C20.5612 6.24745 20.4131 6.20972 20.2636 6.17498" stroke="#B82C33" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
          </g>
          </svg>
        </div>
        <div class="ebook-line-item__content">
        <p class="ebook-line-item__title">${window.Shopify.theme_settings.ebook_title}</p>
        <p class="ebook-line-item__meta">${window.Shopify.theme_settings.in_cart_js_html.replace('{{currency_symbol}}', window.Currency.symbol)}</p>
        <span class="ebook-line-item__price">${window.Shopify.translation.cart_free_text}</span>
        </div>
      </div>`;
      if (ebookPaidInCart > 0) {
        removeEbook(paidEbook);
        if(ebookFreeInCart == 0){
          addEbook(freeEbook);
        }
      }

    } else if ( ebookMissing >= 0) {
      
      cartEbook =`<div class="ebook-wrapper">
      <div class="ebook-icon"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.2266 21.7969H12.7734" stroke="#B82C33" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
        <mask id="mask0_1062_1225" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <path d="M0 1.90735e-06H24V24H0V1.90735e-06Z" fill="white"></path>
        </mask>
        <g mask="url(#mask0_1062_1225)">
        <path d="M7.93359 3.45728C7.93359 3.65143 7.77623 3.80884 7.58203 3.80884C7.38783 3.80884 7.23047 3.65143 7.23047 3.45728C7.23047 3.26312 7.38783 3.10571 7.58203 3.10571C7.77623 3.10571 7.93359 3.26312 7.93359 3.45728Z" fill="#B82C33"></path>
        <path d="M9.53906 3.45728C9.53906 3.65143 9.3817 3.80884 9.1875 3.80884C8.9933 3.80884 8.83594 3.65143 8.83594 3.45728C8.83594 3.26312 8.9933 3.10571 9.1875 3.10571C9.3817 3.10571 9.53906 3.26312 9.53906 3.45728Z" fill="#B82C33"></path>
        <path d="M11.1445 3.45728C11.1445 3.65143 10.9872 3.80884 10.793 3.80884C10.5988 3.80884 10.4414 3.65143 10.4414 3.45728C10.4414 3.26312 10.5988 3.10571 10.793 3.10571C10.9872 3.10571 11.1445 3.26312 11.1445 3.45728Z" fill="#B82C33"></path>
        <path d="M3.70801 6.17505V1.79819C3.70801 0.999252 4.35563 0.35158 5.15462 0.35158H18.8455C19.6445 0.35158 20.2921 0.999252 20.2921 1.79819V6.17505" stroke="#B82C33" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
        <path d="M20.2921 18.993V22.2018C20.2921 23.0008 19.6445 23.6484 18.8455 23.6484H5.15462C4.35563 23.6484 3.70801 23.0008 3.70801 22.2018V18.993" stroke="#B82C33" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
        <path d="M18.3698 18.5322V19.4625C18.3698 19.8337 18.0689 20.1345 17.6978 20.1345H6.30237C5.93126 20.1345 5.63037 19.8337 5.63037 19.4625V18.5257" stroke="#B82C33" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
        <path d="M5.63037 4.64062V2.94591C5.63037 2.57475 5.93126 2.27391 6.30237 2.27391H17.6978C18.0689 2.27391 18.3698 2.57475 18.3698 2.94591V4.64062" stroke="#B82C33" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
        <path d="M5.63037 4.64062H18.3698" stroke="#B82C33" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
        <path d="M12 6.17724V18.5322" stroke="#B82C33" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
        <path d="M20.2634 14.0554V5.43534C20.2634 5.14969 20.0629 4.90505 19.7839 4.84383C15.818 3.97444 11.9999 6.17723 11.9999 6.17723C11.9999 6.17723 8.18177 3.97444 4.21581 4.84383C3.93681 4.90505 3.73633 5.14969 3.73633 5.43534V7.7498" stroke="#B82C33" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
        <path d="M3.73633 9.39338V16.6356C3.73633 17.015 4.08175 17.2993 4.45459 17.2288C7.71109 16.6134 10.8176 18.0054 11.7309 18.468C11.9 18.5536 12.0998 18.5536 12.2688 18.468C13.1821 18.0054 16.2887 16.6134 19.5452 17.2288C19.918 17.2993 20.2634 17.015 20.2634 16.6356V15.699" stroke="#B82C33" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
        <path d="M3.73655 6.17498C3.58711 6.20972 3.43904 6.24745 3.29269 6.28893L2.88525 6.40439C2.51086 6.51042 2.25244 6.85223 2.25244 7.24139V18.1559C2.25244 18.7331 2.80421 19.1502 3.35954 18.9929L4.07232 18.7909C7.25836 17.8882 10.4048 19.3799 11.5485 20.0187C11.8289 20.1752 12.1705 20.1754 12.4511 20.0194C13.5973 19.382 16.7562 17.8923 19.9279 18.7909L20.6407 18.9929C21.196 19.1502 21.7478 18.7331 21.7478 18.1559V7.24139C21.7478 6.85223 21.4894 6.51042 21.1149 6.40439L20.7075 6.28893C20.5612 6.24745 20.4131 6.20972 20.2636 6.17498" stroke="#B82C33" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
        </g>
        </svg>
      </div>
        <div class="ebook-text">
        <p>${window.Shopify.theme_settings.amount_too_small_js_html.replace('{{currency_symbol}}', window.Currency.symbol).replace('{{currency_symbol}}', window.Currency.symbol).replace('{{amount_away}}', ebookMissing)}</p>
        </div>
      </div>`;
      if (ebookFreeInCart > 0) {
        removeEbook(freeEbook);
        if(ebookPaidInCart == 0){
          addEbook(paidEbook);
        }
      }
    }
    
    $('.cart_content .ebook-content').empty().html(cartEbook);

    }

    if (window.Shopify.theme_settings.show_free_shipping_progress) {
      const $fsBar = $('.js-free-shipping-bar');
      const fsThreshold = window.Shopify.theme_settings.free_shipping_threshold || 0;

      if (fsThreshold > 0 && $fsBar.length) {
        let fsTotal = 0;
        cart.items.forEach(item => {
          if (item.requires_shipping) {
            fsTotal += item.final_line_price;
          }
        });

        let fsRemaining = fsThreshold - fsTotal;
        if (fsRemaining < 0) fsRemaining = 0;

        const fsPercent = Math.min(100, Math.round((fsTotal * 100) / fsThreshold));
        let fsMessage;

        if (fsRemaining > 0) {
          const fsMoney = window.Shopify.formatMoney(fsRemaining, $('body').data('money-format'));
          fsMessage = window.Shopify.theme_settings.free_shipping_remaining_html.replace('{{amount}}', fsMoney);
          $fsBar.removeClass('free-shipping-bar--unlocked');
        } else {
          fsMessage = window.Shopify.theme_settings.free_shipping_success_html;
          $fsBar.addClass('free-shipping-bar--unlocked');
        }

        $fsBar.find('.free-shipping-bar__message').html(fsMessage);
        $fsBar.find('.free-shipping-bar__fill').css('width', `${fsPercent}%`);
        $fsBar.find('.free-shipping-bar__track').attr('aria-valuenow', fsPercent);
      }
    }

    $('.js-cart_items').html(cartItemsHTML);
    $('.js-cart_discounts').html(cartDiscountsHTML);
    $('.js-cart_subtotal').html(cartActionHTML);
    $('.js-cart_savings').html(cartSavingsHTML);

    // Converting the currencies
    if (window.Currency.show_multiple_currencies) {
      window.currencyConverter.convertCurrencies();
    }
  }
  $(document).on('click','.add_to_cart_ebook', function(e){
    e.preventDefault();
    console.log('add ebook');
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: freeEbook // ebook id
      },
        dataType: 'json', 
       success: function (data) { 

        $.ajax({
          url: '/cart.js',
          dataType: 'json',
          cache: false,
          success(cart) {
            setTimeout(function () {
              
              if(window.location.href.includes('cart')){
                location.reload();
              } else {
                refreshCart(cart);
              }
            }, 500);
          }
        });

       
      },
       error(XMLHttpRequest) {

        console.log(XMLHttpRequest);

      },
    });

  });

  $('body').on('change', '[data-cart-quantity-input]', function () {
    const cartItem = {
      lineID: $(this).parents('[data-cart-item]').data('line-id'),
      variantID: $(this).parents('[data-cart-item]').data('variant-id'),
      quantity: $(this).val(),
      parentCartForm: $(this).parents('[data-cart-form]'),
      totalDiscount: $(this).parents('[data-cart-form]').data('total-discount'),
      $element: $(this).parents('[data-cart-item]'),
    };
    // Disable button after click to prevent multiple clicks
    $(this).parents('.product-quantity-box').find('.js-change-quantity').addClass('is-disabled');
    updateCartItemQuantity(cartItem);
  });

  $('body').on('click', '[data-remove-item]', function (e) {
    e.preventDefault();
    const cartItem = {
      lineID: $(this).parents('[data-cart-item]').data('line-id'),
      variantID: $(this).parents('[data-cart-item]').data('variant-id'),
      quantity: 0,
      parentCartForm: $(this).parents('[data-cart-form]'),
      totalDiscount: $(this).parents('[data-cart-form]').data('total-discount'),
      $element: $(this).parents('[data-cart-item]'),
    };
    cartItem.$element.addClass('animated fadeOutLeft');

    updateCartItemQuantity(cartItem);

    if (cartItem.parentCartForm.data('cart-form') === 'cart-template') {
      cartItem.$element.find('input').val('0');
      cartItem.parentCartForm.submit();
    }

    if (cartItem.parentCartForm.data('cart-form') === 'mini-cart') {
      cartItem.$element.find('input').val('0');
    }
  });

  if (window.Shopify.theme_settings.cart_action === 'ajax') {
    $(document).on('click', '.ajax-submit', function (e) {
      e.preventDefault();
      if($(this).hasClass('must_be_disabled')) {
        return;
      }
      const $addToCartForm = $(this).closest('form');
      const $addToCartBtn = $addToCartForm.find('.add_to_cart');

      // Refresh page on quick shop add to cart if on cart page
      if ($('body').hasClass('cart')) {
        $addToCartForm.submit();
      }

      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: $addToCartForm.serialize(),
        beforeSend() {
          $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
          $addToCartBtn.find('span').removeClass('fadeInDown').addClass('animated zoomOut');
        },
        success() {
          $addToCartBtn.find('.checkmark').addClass('checkmark-active');

          window.setTimeout(() => {
            $addToCartBtn.removeAttr('disabled').removeClass('disabled');
            $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
            $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
          }, 1000);

          $.ajax({
            url: '/cart.js',
            dataType: 'json',
            cache: false,
            success(cart) {
              setTimeout(function () {
                refreshCart(cart);
                if ($('body').hasClass('fancybox-active')) {
                  $.fancybox.close();
                }

                if ($('#header').is(':visible')) {
                  $('#header .cart-container').addClass('active_link');
                } else if ($('.sticky_nav--stick').length) {
                  $('.sticky_nav .cart-container').addClass('active_link');
                } else {
                  $('.top-bar .cart-container').addClass('active_link');
                }

                // block scrolling on mobile
                if (window.Shopify.media_queries.medium.matches) {
                  const $cartContainer = $(this).parent();
                  if ($cartContainer.hasClass('active_link')) {
                    $('body').addClass('blocked-scroll');
                  } else {
                    $('body').addClass('blocked-scroll');
                  }
                }
              }, 500);
            },
          });
        },
        error(XMLHttpRequest) {
          let response = eval(`(${XMLHttpRequest.responseText})`);
          response = response.description;
          $('.warning').remove();

          const warning = `<p class="warning animated bounceIn">${response.replace('All 1 ', 'All ')}</p>`;
          $addToCartForm.after(warning);
          $addToCartBtn.removeAttr('disabled').removeClass('disabled');
          $addToCartBtn.find('span').text(window.Shopify.translation.add_to_cart).removeClass('zoomOut').addClass('zoomIn');
        },
      });

      return false;
    });
  }

  function openMiniCartAfterAdd() {
    if ($("#header").is(":visible")) {
      $("#header .cart-container").addClass("active_link");
    } else if ($(".sticky_nav--stick").length) {
      $(".sticky_nav .cart-container").addClass("active_link");
    } else {
      $(".top-bar .cart-container").addClass("active_link");
    }

    if (window.Shopify.media_queries.medium.matches) {
      $("body").addClass("blocked-scroll");
    }
  }

  $(document).on("click", ".js-quick-add-chip", function (e) {
    e.preventDefault();
    e.stopPropagation();

    const $chip = $(this);
    if (
      $chip.prop("disabled") ||
      $chip.hasClass("size-button--out-of-stock") ||
      $chip.hasClass("is-loading")
    ) {
      return;
    }

    const variantId = $chip.data("variant-id");
    if (!variantId) {
      return;
    }

    const $overlay = $chip.closest("[data-quick-add-overlay]");
    const $error = $overlay.find("[data-quick-add-error]");
    $error.text("").prop("hidden", true);
    $chip.addClass("is-loading").prop("disabled", true);

    $.ajax({
      url: "/cart/add.js",
      dataType: "json",
      cache: false,
      type: "post",
      data: {
        id: variantId,
        quantity: 1,
      },
      success() {
        $.ajax({
          url: "/cart.js",
          dataType: "json",
          cache: false,
          success(cart) {
            setTimeout(function () {
              refreshCart(cart);
              openMiniCartAfterAdd();
            }, 500);
          },
        });
      },
      error(xhr) {
        let message = "Unable to add to cart";
        try {
          message = JSON.parse(xhr.responseText).description;
        } catch (err) {
          // Keep the fallback message when the response is not JSON.
        }
        $error.text(message).prop("hidden", false);
      },
      complete() {
        window.setTimeout(function () {
          if (!$chip.hasClass("size-button--out-of-stock")) {
            $chip.removeClass("is-loading").prop("disabled", false);
          }
        }, 400);
      },
    });
  });

  window.productPage.productSwatches();
});

/*= ===========================================================================
  Swatch options - second and third swatch 'sold-out' will update based on availability of previous options selected
============================================================================== */
window.Shopify.updateOptionsInSelector = function (selectorIndex, parent) {
  switch (selectorIndex) {
    case 0:
      var key = 'root';
      break;
    case 1:
      var key = $(`${parent} .single-option-selector:eq(0)`).val();
      break;
    case 2:
      var key = $(`${parent} .single-option-selector:eq(0)`).val();
      key += ` / ${$(`${parent} .single-option-selector:eq(1)`).val()}`;
  }

  const availableOptions = Shopify.optionsMap[key];
  $(`${parent} .swatch[data-option-index="${selectorIndex}"] .swatch-element`).each(function () {
    if ($.inArray($(this).attr('data-value'), availableOptions) !== -1) {
      $(this).removeClass('soldout').find(':radio').removeAttr('disabled', 'disabled')
        .removeAttr('checked');
    } else {
      $(this).addClass('soldout').find(':radio').removeAttr('checked')
        .attr('disabled', 'disabled');
    }
  });
};

window.Shopify.linkOptionSelectors = function (product, parent) {
  // Building our mapping object.
  window.Shopify.optionsMap = {};
  for (let i = 0; i < product.variants.length; i++) {
    const variant = product.variants[i];
    if (variant.available) {
      // Gathering values for the 1st drop-down.
      window.Shopify.optionsMap.root = window.Shopify.optionsMap.root || [];
      window.Shopify.optionsMap.root.push(variant.option1);
      window.Shopify.optionsMap.root = window.Shopify.uniq(window.Shopify.optionsMap.root);
      // Gathering values for the 2nd drop-down.
      if (product.options.length > 1) {
        const key = variant.option1;
        window.Shopify.optionsMap[key] = window.Shopify.optionsMap[key] || [];
        window.Shopify.optionsMap[key].push(variant.option2);
        window.Shopify.optionsMap[key] = window.Shopify.uniq(window.Shopify.optionsMap[key]);
      }
      // Gathering values for the 3rd drop-down.
      if (product.options.length === 3) {
        const key = `${variant.option1} / ${variant.option2}`;
        window.Shopify.optionsMap[key] = window.Shopify.optionsMap[key] || [];
        window.Shopify.optionsMap[key].push(variant.option3);
        window.Shopify.optionsMap[key] = window.Shopify.uniq(window.Shopify.optionsMap[key]);
      }
    }
  }
  // Update options right away.
  window.Shopify.updateOptionsInSelector(0, parent);
  if (product.options.length > 1) window.Shopify.updateOptionsInSelector(1, parent);
  if (product.options.length === 3) window.Shopify.updateOptionsInSelector(2, parent);
  // When there is an update in the first dropdown.
  $(`${parent} .single-option-selector:eq(0)`).change(() => {
    window.Shopify.updateOptionsInSelector(1, parent);
    if (product.options.length === 3) window.Shopify.updateOptionsInSelector(2, parent);
    return true;
  });
  // When there is an update in the second dropdown.
  $(`${parent} .single-option-selector:eq(1)`).change(() => {
    if (product.options.length === 3) window.Shopify.updateOptionsInSelector(2, parent);
    return true;
  });
};

// Used for cart functionality
window.htmlEncode = function htmlEncode(value) {
  if (value) {
    return $('<div/>').text(value).html();
  }
  return '';
};

// Check if device is touch-enabled
window.is_touch_device = function is_touch_device() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
};

// Differentiate between mobile and touch screen laptops
window.touch_device = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);

/* option_selection.js */
function floatToString(t,e){var o=t.toFixed(e).toString();return o.match(/^\.\d+/)?"0"+o:o}if("undefined"==typeof window.Shopify) window.Shopify={};window.Shopify.each=function(t,e){for(var o=0;o<t.length;o++)e(t[o],o)},window.Shopify.map=function(t,e){for(var o=[],i=0;i<t.length;i++)o.push(e(t[i],i));return o},window.Shopify.arrayIncludes=function(t,e){for(var o=0;o<t.length;o++)if(t[o]==e)return!0;return!1},window.Shopify.uniq=function(t){for(var e=[],o=0;o<t.length;o++)window.Shopify.arrayIncludes(e,t[o])||e.push(t[o]);return e},window.Shopify.isDefined=function(t){return"undefined"==typeof t?!1:!0},window.Shopify.getClass=function(t){return Object.prototype.toString.call(t).slice(8,-1)},window.Shopify.extend=function(t,e){function o(){}o.prototype=e.prototype,t.prototype=new o,t.prototype.constructor=t,t.baseConstructor=e,t.superClass=e.prototype},window.Shopify.locationSearch=function(){return window.location.search},window.Shopify.locationHash=function(){return window.location.hash},window.Shopify.replaceState=function(t){window.history.replaceState({},document.title,t)},window.Shopify.urlParam=function(t){var e=RegExp("[?&]"+t+"=([^&#]*)").exec(window.Shopify.locationSearch());return e&&decodeURIComponent(e[1].replace(/\+/g," "))},window.Shopify.newState=function(t,e){var o;return o=window.Shopify.urlParam(t)?window.Shopify.locationSearch().replace(RegExp("("+t+"=)[^&#]+"),"$1"+e):""===window.Shopify.locationSearch()?"?"+t+"="+e:window.Shopify.locationSearch()+"&"+t+"="+e,o+window.Shopify.locationHash()},window.Shopify.setParam=function(t,e){window.Shopify.replaceState(window.Shopify.newState(t,e))},window.Shopify.Product=function(t){window.Shopify.isDefined(t)&&this.update(t)},window.Shopify.Product.prototype.update=function(t){for(property in t)this[property]=t[property]},window.Shopify.Product.prototype.optionNames=function(){return"Array"==window.Shopify.getClass(this.options)?this.options:[]},window.Shopify.Product.prototype.optionValues=function(t){if(!window.Shopify.isDefined(this.variants))return null;var e=window.Shopify.map(this.variants,function(e){var o="option"+(t+1);return void 0==e[o]?null:e[o]});return null==e[0]?null:window.Shopify.uniq(e)},window.Shopify.Product.prototype.getVariant=function(t){var e=null;return t.length!=this.options.length?e:(window.Shopify.each(this.variants,function(o){for(var i=!0,r=0;r<t.length;r++){var n="option"+(r+1);o[n]!=t[r]&&(i=!1)}return 1==i?void(e=o):void 0}),e)},window.Shopify.Product.prototype.getVariantById=function(t){for(var e=0;e<this.variants.length;e++){var o=this.variants[e];if(t==o.id)return o}return null},window.Shopify.money_format="$",window.Shopify.formatMoney=function(t,e){function o(t,e){return"undefined"==typeof t?e:t}function i(t,e,i,r){if(e=o(e,2),i=o(i,","),r=o(r,"."),isNaN(t)||null==t)return 0;t=(t/100).toFixed(e);var n=t.split("."),a=n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+i),s=n[1]?r+n[1]:"";return a+s}"string"==typeof t&&(t=t.replace(".",""));var r="",n=/\{\{\s*(\w+)\s*\}\}/,a=e||this.money_format;switch(a.match(n)[1]){case"amount":r=i(t,2);break;case"amount_no_decimals":r=i(t,0);break;case"amount_with_comma_separator":r=i(t,2,".",",");break;case"amount_with_apostrophe_separator":r=i(t,2,"'",".");break;case"amount_no_decimals_with_comma_separator":r=i(t,0,".",",")}return a.replace(n,r)},window.Shopify.OptionSelectors=function(t,e){return this.selectorDivClass="selector-wrapper",this.selectorClass="single-option-selector",this.variantIdFieldIdSuffix="-variant-id",this.variantIdField=null,this.historyState=null,this.selectors=[],this.domIdPrefix=t,this.product=new window.Shopify.Product(e.product),this.onVariantSelected=window.Shopify.isDefined(e.onVariantSelected)?e.onVariantSelected:function(){},this.replaceSelector(t),this.initDropdown(),e.enableHistoryState&&(this.historyState=new window.Shopify.OptionSelectors.HistoryState(this)),!0},window.Shopify.OptionSelectors.prototype.initDropdown=function(){var t={initialLoad:!0},e=this.selectVariantFromDropdown(t);if(!e){var o=this;setTimeout(function(){o.selectVariantFromParams(t)||o.fireOnChangeForFirstDropdown.call(o,t)})}},window.Shopify.OptionSelectors.prototype.fireOnChangeForFirstDropdown=function(t){this.selectors[0].element.onchange(t)},window.Shopify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown=function(t){var e=this.selectVariantFromParams(t);e||this.selectVariantFromDropdown(t)},window.Shopify.OptionSelectors.prototype.replaceSelector=function(t){var e=document.getElementById(t),o=e.parentNode;window.Shopify.each(this.buildSelectors(),function(t){o.insertBefore(t,e)}),e.style.display="none",this.variantIdField=e},window.Shopify.OptionSelectors.prototype.selectVariantFromDropdown=function(t){var e=document.getElementById(this.domIdPrefix).querySelector("[selected]");if(e||(e=document.getElementById(this.domIdPrefix).querySelector('[selected="selected"]')),!e)return!1;var o=e.value;return this.selectVariant(o,t)},window.Shopify.OptionSelectors.prototype.selectVariantFromParams=function(t){var e=window.Shopify.urlParam("variant");return this.selectVariant(e,t)},window.Shopify.OptionSelectors.prototype.selectVariant=function(t,e){var o=this.product.getVariantById(t);if(null==o)return!1;for(var i=0;i<this.selectors.length;i++){var r=this.selectors[i].element,n=r.getAttribute("data-option"),a=o[n];null!=a&&this.optionExistInSelect(r,a)&&(r.value=a)}return"undefined"!=typeof jQuery?jQuery(this.selectors[0].element).trigger("change",e):this.selectors[0].element.onchange(e),!0},window.Shopify.OptionSelectors.prototype.optionExistInSelect=function(t,e){for(var o=0;o<t.options.length;o++)if(t.options[o].value==e)return!0},window.Shopify.OptionSelectors.prototype.insertSelectors=function(t,e){window.Shopify.isDefined(e)&&this.setMessageElement(e),this.domIdPrefix="product-"+this.product.id+"-variant-selector";var o=document.getElementById(t);window.Shopify.each(this.buildSelectors(),function(t){o.appendChild(t)})},window.Shopify.OptionSelectors.prototype.buildSelectors=function(){for(var t=0;t<this.product.optionNames().length;t++){var e=new window.Shopify.SingleOptionSelector(this,t,this.product.optionNames()[t],this.product.optionValues(t));e.element.disabled=!1,this.selectors.push(e)}var o=this.selectorDivClass,i=this.product.optionNames(),r=window.Shopify.map(this.selectors,function(t){var e=document.createElement("div");if(e.setAttribute("class",o),i.length>1){var r=document.createElement("label");r.htmlFor=t.element.id,r.innerHTML=t.name,e.appendChild(r)}return e.appendChild(t.element),e});return r},window.Shopify.OptionSelectors.prototype.selectedValues=function(){for(var t=[],e=0;e<this.selectors.length;e++){var o=this.selectors[e].element.value;t.push(o)}return t},window.Shopify.OptionSelectors.prototype.updateSelectors=function(t,e){var o=this.selectedValues(),i=this.product.getVariant(o);i?(this.variantIdField.disabled=!1,this.variantIdField.value=i.id):this.variantIdField.disabled=!0,this.onVariantSelected(i,this,e),null!=this.historyState&&this.historyState.onVariantChange(i,this,e)},window.Shopify.OptionSelectorsFromDOM=function(t,e){var o=e.optionNames||[],i=e.priceFieldExists||!0,r=e.delimiter||"/",n=this.createProductFromSelector(t,o,i,r);e.product=n,window.Shopify.OptionSelectorsFromDOM.baseConstructor.call(this,t,e)},window.Shopify.extend(window.Shopify.OptionSelectorsFromDOM,window.Shopify.OptionSelectors),window.Shopify.OptionSelectorsFromDOM.prototype.createProductFromSelector=function(t,e,o,i){if(!window.Shopify.isDefined(o))var o=!0;if(!window.Shopify.isDefined(i))var i="/";var r=document.getElementById(t),n=r.childNodes,a=(r.parentNode,e.length),s=[];window.Shopify.each(n,function(t,r){if(1==t.nodeType&&"option"==t.tagName.toLowerCase()){var n=t.innerHTML.split(new RegExp("\\s*\\"+i+"\\s*"));0==e.length&&(a=n.length-(o?1:0));var p=n.slice(0,a),l=o?n[a]:"",c=(t.getAttribute("value"),{available:t.disabled?!1:!0,id:parseFloat(t.value),price:l,option1:p[0],option2:p[1],option3:p[2]});s.push(c)}});var p={variants:s};if(0==e.length){p.options=[];for(var l=0;a>l;l++)p.options[l]="option "+(l+1)}else p.options=e;return p},window.Shopify.SingleOptionSelector=function(t,e,o,i){this.multiSelector=t,this.values=i,this.index=e,this.name=o,this.element=document.createElement("select");for(var r=0;r<i.length;r++){var n=document.createElement("option");n.value=i[r],n.innerHTML=i[r],this.element.appendChild(n)}return this.element.setAttribute("class",this.multiSelector.selectorClass),this.element.setAttribute("data-option","option"+(e+1)),this.element.id=t.domIdPrefix+"-option-"+e,this.element.onchange=function(o,i){i=i||{},t.updateSelectors(e,i)},!0},window.Shopify.Image={preload:function(t,e){for(var o=0;o<t.length;o++){var i=t[o];this.loadImage(this.getSizedImageUrl(i,e))}},loadImage:function(t){(new Image).src=t},switchImage:function(t,e,o){if(t&&e){var i=this.imageSize(e.src),r=this.getSizedImageUrl(t.src,i);o?o(r,t,e):e.src=r}},imageSize:function(t){var e=t.match(/_(1024x1024|2048x2048|pico|icon|thumb|small|compact|medium|large|grande)\./);return null!=e?e[1]:null},getSizedImageUrl:function(t,e){if(null==e)return t;if("master"==e)return this.removeProtocol(t);var o=t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);if(null!=o){var i=t.split(o[0]),r=o[0];return this.removeProtocol(i[0]+"_"+e+r)}return null},removeProtocol:function(t){return t.replace(/http(s)?:/,"")}},window.Shopify.OptionSelectors.HistoryState=function(t){this.browserSupports()&&this.register(t)},window.Shopify.OptionSelectors.HistoryState.prototype.register=function(t){window.addEventListener("popstate",function(e){t.selectVariantFromParamsOrDropdown({popStateCall:!0})})},window.Shopify.OptionSelectors.HistoryState.prototype.onVariantChange=function(t,e,o){this.browserSupports()&&(!t||o.initialLoad||o.popStateCall||window.Shopify.setParam("variant",t.id))},window.Shopify.OptionSelectors.HistoryState.prototype.browserSupports=function(){return window.history&&window.history.replaceState};

$(document)
  .on('shopify:block:select', function(e){

    var blockId = e.detail.blockId;
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('shopify-section--slideshow') || $parentSection.hasClass('shopify-section--testimonials')) {
      sliderBlock.select(blockId, $parentSection);
    }

    if ($parentSection.find('.block__recommended_products')) {
      productPage.unload($parentSection);
      window.productPage.init();
      window.productPage.runOptionSelector();
    }

    if($parentSection.hasClass('shopify-section--page-details-template')) {
      if($('.shopify-section--map').length) {
        window.map.init();
      }

      if($('.shopify-section--featured-collection').length) {
        window.featuredCollection.init();
        window.videoFeature.init();
      }

      if ($('shopify-section--video').length) {
       window.video.init();
      }

      if($('.recently-viewed__section').length && window.Shopify.theme_settings.collection_secondary_image) {
        window.imageFunctions.showSecondaryImage();
      }
    }

    if ($parentSection.hasClass('shopify-section--cart-template')) {
      if ($('.block__featured_collection').length){
        window.featuredCollection.init();
      }
    }

    if ($parentSection.hasClass('shopify-section--product-template')) {
      if (window.Shopify.theme_settings.enable_shopify_review_comments) {
        if($('#shopify-product-reviews').length >= 1) {
          SPR.$(document).ready(function() {
            return SPR.registerCallbacks(),
            SPR.initRatingHandler(),
            SPR.initDomEls(),
            SPR.loadProducts(),
            SPR.loadBadges()
          })
        }
      }
    }

});

$(document)
  .on('shopify:block:deselect', function(e){

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('shopify-section--slideshow') || $parentSection.hasClass('shopify-section--testimonials')) {
      window.sliderBlock.deselect($parentSection);
    }
});

$(document)
  .on('shopify:section:reorder', function(e){
    window.utils.pageBannerCheck();
});

$(document)
  .on('shopify:section:load', function(e){

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    window.utils.pageBannerCheck();
    window.utils.enableDisclosure();

    if (window.Shopify.theme_settings.enable_autocomplete) {
      window.searchAutocomplete.init();
    }

    if (window.Shopify.theme_settings.newsletter_popup) {
      window.newsletter_popup.init();
    }

    if ($parentSection.hasClass('shopify-section--article-template')) {
      window.sidebarAccordions.init();
    }

    if ($parentSection.hasClass('shopify-section--blog-template')) {
      window.sidebarAccordions.init();
    }

    if ($parentSection.hasClass('shopify-section--product-sidebar')) {
      window.sidebarAccordions.init();
    }

    if ($parentSection.hasClass('shopify-section--page-gallery-template')) {
      window.gallery.init($parentSection);
    }

    if ($parentSection.hasClass('shopify-section--gallery')) {
      window.gallery.init();
    }

    if ($parentSection.hasClass('shopify-section--page-faq-template') || $parentSection.hasClass('shopify-section--faq')) {
      window.globalAccordions.init();
    }

    if ($parentSection.hasClass('shopify-section--cart-template')) {
      window.cart.init();

      if ($('.block__featured_collection').length) {
        window.featuredCollection.init();
      }
    }

    if ($parentSection.hasClass('shopify-section--featured-promotions')) {
      window.featuredPromotions.init();
    }

    if ($parentSection.hasClass('shopify-section--slideshow')) {
      window.slideshow.init();
    }

    if ($parentSection.hasClass('shopify-section--testimonials')) {
      window.testimonials.init();
    }

    if ($parentSection.hasClass('shopify-section--featured-product') || $parentSection.hasClass('shopify-section--quickshop')) {
      window.productPage.init();
      window.productPage.runOptionSelector();
      window.videoFeature.init();
      window.productPage.productSwatches();
      if (window.Shopify.theme_settings.enable_shopify_review_comments) {
        if ($('.shopify-product-reviews-badge').length) {
          SPR.$(document).ready(function() {
            return SPR.registerCallbacks(),
            SPR.initRatingHandler(),
            SPR.initDomEls(),
            SPR.loadProducts(),
            SPR.loadBadges()
          })
        }
      }
    }

    if($parentSection.hasClass('shopify-section--map')) {
      window.map.init();
    }

    if ($parentSection.hasClass('shopify-section--featured-collection')) {
      window.featuredCollection.init();
      window.videoFeature.init();
    }

    if ($parentSection.hasClass('shopify-section--video')) {
      window.video.init();
    }

    if ($parentSection.hasClass('shopify-section--product-template')
      || $parentSection.hasClass('shopify-section--quick-shop')) {
      window.productPage.init();
      window.productPage.runOptionSelector();
      window.videoFeature.init();
      window.productPage.productSwatches();
      window.recentlyViewed.init();
      if (window.Shopify.theme_settings.enable_shopify_review_comments) {
        if($('#shopify-product-reviews').length || $('.shopify-product-reviews-badge').length) {
          SPR.$(document).ready(function() {
            return SPR.registerCallbacks(),
            SPR.initRatingHandler(),
            SPR.initDomEls(),
            SPR.loadProducts(),
            SPR.loadBadges()
          })
        }
      }

      // Product review scroll
      window.utils.productReviewScroll();
    }

    if ($parentSection.hasClass('shopify-section--recommended-products')) {
      window.productPage.init();
      window.productPage.runOptionSelector();
    }

    if ($parentSection.hasClass('shopify-section--recently-viewed-products')) {
      window.recentlyViewed.init();
    }

    if ($parentSection.hasClass('shopify-section--article-template')) {
      if(window.location.pathname.indexOf('/comments') != -1) {
        $('html,body').animate({scrollTop: $("#new-comment").offset().top-140},'slow');
      }
    }

    if ($parentSection.hasClass('shopify-section--collection-template')) {
      window.collectionSidebarFilter.init();
      window.recentlyViewed.init();
      window.productPage.runOptionSelector();
      window.sidebarAccordions.init();
    }

    if($parentSection.hasClass('shopify-section--contact-section')) {
      window.map.init();
    }

    if ($parentSection.hasClass('shopify-section--search-template')) {
      if (window.Shopify.theme_settings.enable_autocomplete){
        window.searchAutocomplete.init();
      }
      window.collectionSidebarFilter.init();
      window.sidebarAccordions.init();
    }

    if ($parentSection.hasClass('shopify-section--header')) {
      window.header.init();
      window.header.loadMegaMenu();
    }

    if ($parentSection.hasClass('shopify-section--mega-menu')) {
      window.header.loadMegaMenu();
    }

    if ($parentSection.hasClass('shopify-section--page-details-template')) {
      window.featuredCollection.init();
      window.video.init();
      window.recentlyViewed.init();

      if($('.block__image_gallery').length) {
        window.gallery.init();
      };
    }
});


$(document)
  .on('shopify:section:unload', function(e){
    var $target = $(e.target);
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('shopify-section--header')) {
      window.header.unload($target);
      window.header.unloadMegaMenu();
    }

    if ($parentSection.hasClass('shopify-section--slideshow')) {
      window.slideshow.unload($target);
    }

    if ($parentSection.hasClass('shopify-section--testimonials')) {
      window.testimonials.unload($target);
    }

    if ($parentSection.hasClass('shopify-section--search')) {
      window.searchAutocomplete.unload($target);
    }

    if ($parentSection.hasClass('shopify-section--product-template')) {
      window.productPage.unload($parentSection);
    }

    if ($parentSection.hasClass('shopify-section--featured-product')) {
      window.productPage.unload($parentSection);
    }

    if ($parentSection.hasClass('shopify-section--mega-menu')) {
      window.header.unloadMegaMenu();
    }
});

$(document)
  .on('shopify:section:select', function(e){

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('shopify-section--mega-menu')) {
      var megaMenuParent = $('.header .' + e.detail.sectionId).data('dropdown');
      setTimeout(function() {
        $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').trigger('mouseenter');
        $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').parents('header').addClass('editor-hover--true');
        header.removeDataAttributes('.header .mega-menu.dropdown_container .dropdown_column');
      }, 10);
    }

    if ($parentSection.hasClass('shopify-section--featured-collection')) {
      window.featuredCollection.unload($parentSection);
      window.featuredCollection.init();
    }

    window.utils.pageBannerCheck();
    var evt = document.createEvent('UIEvents');
    evt.initUIEvent('resize', true, false, window, 0);
    window.dispatchEvent(evt);
});

$(document)
  .on('shopify:section:deselect', function(e){

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('shopify-section--mega-menu')) {
      var megaMenuParent = $('.header .' + e.detail.sectionId).data('dropdown');
      $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').trigger('mouseout');
      $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').parents('header').removeClass('editor-hover--true');
    }
});

if(window.location.href.includes('cart')){
  let freeEbook = 47406069154128;
  let paidEbook = 40558528757821;
  function addEbookonLoad(fid) {
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: fid // ebook id
      },
      dataType: 'json', 
      success: function (data) {
       
      },
       error(XMLHttpRequest) {

        console.log(XMLHttpRequest);

      },
    });
  }

  function removeEbookonLoad(fid) {
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: {
        id: fid,
        quantity: 0
      },
      dataType: 'json', 
      success: function (data) {

      },
      error(XMLHttpRequest) {

       console.log(XMLHttpRequest);

     }
    });
  }

  $.ajax({
  url: '/cart.js',
  dataType: 'json',
  cache: false,
  success(cart) {
    console.log(cart);
    var ebookInCart = 0;
    var ebookPaidInCart = 0;
    var ebookFreeInCart = 0;
    var cTotal = 0;
    var refresh = 0;
    console.log(cart);
    cart.items.forEach((item, index) => {
      if(item.id == paidEbook) {
        ebookInCart += 1;
        ebookPaidInCart += 1;
        
      } else if( item.id == freeEbook ) {
        ebookInCart += 1;
        ebookFreeInCart += 1;
      } else {
        cTotal += item.final_price * item.quantity;
      }
    });
    var ebookMargin = window.Shopify.theme_settings.ebook_free_threshold || 5000;
    ebookMissing = (ebookMargin - cTotal) * 0.01;
   
    if ( ebookInCart == 0 && ebookMissing < 0 ) {

    } else if (ebookInCart > 0 && ebookMissing < 0) {
      if (ebookPaidInCart > 0) {
        removeEbookonLoad(paidEbook);
        refresh = 1;  
        if(ebookFreeInCart == 0){
          addEbookonLoad(freeEbook);
        }
      }
    } else if ( ebookMissing >= 0) {
      if (ebookFreeInCart > 0) {
        removeEbookonLoad(freeEbook);
        refresh = 1;  
        if(ebookPaidInCart == 0){
          addEbookonLoad(paidEbook);

        }
      }
    }
    if(refresh == 1) {
      setTimeout(function () {
        location.reload();
        // if(window.location.href.includes('cart')){
        //   location.reload();
        // } else {
        //   refreshCart(cart);
        // }
      }, 100);
    }



  }
});

}





// $.ajax({
//   url: '/cart.js',
//   dataType: 'json',
//   cache: false,
//   success(cart) {
//     console.log(cart);
//     var ebookInCart = 0;
//     var ebookPaidInCart = 0;
//     var ebookFreeInCart = 0;
//     var cTotal = 0;
//     var refresh = 0;
//     console.log(cart);
//     cart.items.forEach((item, index) => {
//       if(item.id == paidEbook) {
//         ebookInCart += 1;
//         ebookPaidInCart += 1;
        
//       } else if( item.id == freeEbook ) {
//         ebookInCart += 1;
//         ebookFreeInCart += 1;
//       } else {
//         cTotal += item.final_price * item.quantity;
//       }
//     });
//     ebookMissing = (5000 - cTotal) * 0.01;
   
//     if ( ebookInCart == 0 && ebookMissing < 0 ) {

//     } else if (ebookInCart > 0 && ebookMissing < 0) {
//       if (ebookPaidInCart > 0) {
//         removeEbook(paidEbook);
//         refresh = 1;  
//         if(ebookFreeInCart == 0){
//           addEbook(freeEbook);
//         }
//       }
//     } else if ( ebookMissing >= 0) {
//       if (ebookFreeInCart > 0) {
//         removeEbook(freeEbook);
//         refresh = 1;  
//         if(ebookPaidInCart == 0){
//           addEbook(paidEbook);

//         }
//       }
//     }
//     if(refresh == 1) {
//       setTimeout(function () {
      
//         if(window.location.href.includes('cart')){
//           location.reload();
//         } else {
//           refreshCart(cart);
//         }
//       }, 2500);
//     }



//   }
// });

// moneyback lazyload
    // Check for IntersectionObserver support
  if ('IntersectionObserver' in window) {
    document.addEventListener("DOMContentLoaded", function() {

      function handleIntersection(entries) {
        entries.map((entry) => {
          if (entry.isIntersecting) {
            // Item has crossed our observation
            // threshold - load src from data-src
            entry.target.parentNode.style.backgroundImage = "url('"+entry.target.dataset.bg+"')";
            
            // Job done for this item - no need to watch it!
            observer.unobserve(entry.target);
          }
        });
      }
  
      const headers = document.querySelectorAll('.lazybg');
      
      const observer = new IntersectionObserver(
        handleIntersection,
        { rootMargin: "100px" }
      );
      headers.forEach(header => observer.observe(header));
    });
  } else {
    // No interaction support? Load all background images automatically
    const headers = document.querySelectorAll('.lazybg');
    headers.forEach(header => {
      header.parentNode.style.backgroundImage = "url('"+header.dataset.bg+"')";
    });
  }